import { CSS, css as stitchesCss } from "@truepill/capsule-utils";
import cn from "classnames";
import React from "react";
import type {
  PolymorphicForwardRefExoticComponent,
  PolymorphicPropsWithoutRef,
  PolymorphicPropsWithRef,
} from "react-polymorphic-types";

export interface BoxBaseProps {
  /**
   * Allows the passing custom styles to the component.
   */
  css?: CSS;
}

export type BoxProps = PolymorphicPropsWithRef<BoxBaseProps, "div">;

const baseBoxStyles = stitchesCss({});

/**
 * An abstract component to allow the simple creation of layout styles.
 */
export const Box: PolymorphicForwardRefExoticComponent<BoxBaseProps, "div"> =
  React.forwardRef(
    <T extends React.ElementType = "div">(
      {
        as,
        className,
        css,
        ...rest
      }: PolymorphicPropsWithoutRef<BoxBaseProps, T>,
      ref: React.ForwardedRef<Element>
    ) => {
      const Element: React.ElementType = as || "div";
      return (
        <Element
          {...rest}
          className={cn(
            className,
            baseBoxStyles({
              css,
            })
          )}
          ref={ref}
        />
      );
    }
  );
